module.exports = __webpack_public_path__ + "img/intro-infra.905f2a35.png";